import { createContext } from 'react';
import { HttpClient } from './services/http-client';

const apiBaseUrl = "/api";
const token = "";
const loginPath = "/account/login";
const fileBaseUrl = "";

window.location.fileBaseUrl = fileBaseUrl;

const defaultAppContext = {
    apiBaseUrl,
    httpClient: HttpClient.api(apiBaseUrl, token),
    loginPath,
    fileBaseUrl
};

export const AppContext = createContext(defaultAppContext);

function App() {
    return (
        <AppContext.Provider value={defaultAppContext}>
        <div className="App">
            <header className="App-header">
                <p>
                    Insol React Client
                </p>
            </header>
        </div>
        </AppContext.Provider>
    );
}

export default App;
